const  projectsVue = [
    {
       proTitle: "Vue projects", 
       projectProps: [
            {
                title: "project Vue 1",
                img: "./img_projects/Vue/1.png",
                desc: "description project Vue 1",
                location: "/index.html",
                source_code: true
            },
            {
                title: "project Vue 2",
                img: "/img_projects/Vue/1.png",
                desc: "description project Vue 2",
                location: "/index.html",
                source_code: true
            },
            {
                title: "project Vue 2",
                img: "/img_projects/Vue/1.png",
                desc: "description project Vue 2",
                location: "/index.html",
                source_code: true
            },
            {
                title: "project Vue 3",
                img: "/img_projects/Vue/1.png",
                desc: "description project Vue 3",
                location: "/index.html",
                source_code: true
            }
        ]
    }
]

export {projectsVue}
